import React, { useState, useEffect } from "react";
import "./BlogPost.scss";
import { Link, useParams } from "react-router-dom";
import { ReactComponent as Back } from "../../assets/svg/back.svg";
import { client } from "../../sanity/client";
import { urlForImage } from "../../sanity/image";
import { PortableText } from "@portabletext/react";
// import ReactMarkdown from "react-markdown";

const serializers = {
  types: {
    block: (props) => {
      const { style = "normal" } = props.node;
      if (style === "paragraph") {
        return <p>{props.children}</p>;
      } else if (style === "hardbreak") {
        return <br />;
      }
    },
  },
};

const BlogPost = () => {
  const { slug } = useParams();
  const [blogData, setBlogData] = useState([]);
  const fetchData = async () => {
    const query = `*[_type == "post" && slug.current == $slug]{
_id,
title,
slug,
mainImage,
author->{
  name,
  image,
},
description,
publishedAt,
body,
}`;
    const params = { slug };
    const posts = await client.fetch(query, params);

    if (posts && posts.length > 0) {
      setBlogData(posts[0]);
    }
  };
  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slug]);
  return (
    <section className="section blogPost">
      <article className="blogPost__container container">
        <div className="blogPost__content">
          <div className="blogPost__content--header">
            <div className="blogPost__content--header-left">
              <div className="back">
                <Link to="/blog">
                  <Back />
                  <span>Go Home</span>
                </Link>
              </div>

              <h1 className="title">{blogData.title}</h1>

              <div className="author">
                <div className="author__img">
                  {blogData.author?.image && (
                    <img
                      src={urlForImage(blogData.author.image).url()}
                      alt="author"
                    />
                  )}
                </div>

                <div className="author__info">
                  <span className="author__info--name">
                    {blogData.author?.name}
                  </span>
                  <span className="author__info--date">
                    {new Date(blogData.publishedAt).toLocaleDateString(
                      "en-US",
                      {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      }
                    )}
                  </span>
                </div>
              </div>
            </div>

            <div className="blogPost__content--header-right">
              {blogData.mainImage && (
                <img src={urlForImage(blogData.mainImage).url()} alt="blog" />
              )}
            </div>
          </div>
          <div className="blogPost__content--body">
            <PortableText value={blogData?.body} serializers={serializers} />
          </div>
        </div>
      </article>
    </section>
  );
};

export default BlogPost;
